import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=6c52fe8e&scoped=true&"
import script from "./Alert.vue?vue&type=script&lang=ts&"
export * from "./Alert.vue?vue&type=script&lang=ts&"
import style0 from "./Alert.vue?vue&type=style&index=0&id=6c52fe8e&lang=scss&scoped=true&"
import style1 from "./Alert.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c52fe8e",
  null
  
)

export default component.exports